/**
 * API client for the Grit Mile landing page.
 *
 * postLead — POST /leads to the gritmile API Lambda.
 */

import { env } from "./env.js";

export type LeadPayload = {
  email: string;
  variantId: number;
  source: string;
  userAgent: string;
};

/**
 * Submit a lead signup to the API.
 * Throws an Error with the HTTP status if the response is not OK.
 */
export async function postLead(payload: LeadPayload): Promise<void> {
  const response = await fetch(`${env.apiUrl}/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`POST /leads failed: ${response.status}`);
  }
}
